











































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { UploadFile } from '../../request';
@Component({
    components: {},
})
export default class ImgBiaoZhu extends Vue {
    @Prop() imgUrl: any;
    @Prop({ type: Boolean, default: false }) ifShow!: boolean;

    private visible: any = false;
    private displayWidth: number = 0;
    private displayHeight: number = 0;
    private dialogWidth: string = '800px';
    private dialogTop: string = '5vh';
    private isDrawing: boolean = false;
    private ctx: CanvasRenderingContext2D | null = null;
    private originalImage: HTMLImageElement | null = null;
    private paths: any[] = [];
    private currentPath: any[] = [];

    @Watch('ifShow')
    private onIfShowChange(val: boolean) {
        this.visible = val;
        if (val) {
            this.$nextTick(() => {
                this.initCanvas();
            });
        }
    }

    private onImageLoad() {
        const img = this.$refs.image as HTMLImageElement;
        if (img) {
            this.originalImage = img;
            this.calculateDisplaySize();
            // 等待下一个tick确保DOM更新完成
            this.$nextTick(() => {
                this.drawImageOnCanvas();
            });
        }
    }

    private calculateDisplaySize() {
        if (!this.originalImage) return;

        const screenWidth = window.innerWidth;
        const screenHeight = window.innerHeight;

        // 读取底部按钮区高度
        const controlEl = this.$refs.control as HTMLElement | undefined;
        const controlHeight = controlEl?.offsetHeight ?? 72;

        // 对话框安全边距与内边距/边框冗余（可按需微调）
        const verticalMargin = 40;
        const horizontalMargin = 40;
        const paddingAndBorder = 24;

        // 真正可用于图片显示的最大宽高
        const maxWidth = Math.min(
            screenWidth - horizontalMargin * 2 - paddingAndBorder * 2,
            screenWidth * 0.8
        );
        const maxHeight = Math.min(
            screenHeight - verticalMargin * 2 - controlHeight - paddingAndBorder * 2,
            screenHeight * 0.7
        );

        const imgWidth = this.originalImage.naturalWidth;
        const imgHeight = this.originalImage.naturalHeight;

        const scale = Math.min(maxWidth / imgWidth, maxHeight / imgHeight);
        this.displayWidth = Math.floor(imgWidth * scale);
        this.displayHeight = Math.floor(imgHeight * scale);

        // 对话框宽高与位置（宽度尽量贴合图片宽度并保留余量）
        const dialogWidthPx = this.displayWidth + paddingAndBorder * 2;
        if (dialogWidthPx >= screenWidth - horizontalMargin * 2) {
            this.dialogWidth = `calc(100vw - ${horizontalMargin * 2}px)`;
        } else {
            this.dialogWidth = Math.max(dialogWidthPx, 480) + 'px';
        }

        const dialogHeightPx = this.displayHeight + controlHeight + paddingAndBorder * 2;
        const topOffset = Math.max((screenHeight - dialogHeightPx) / 2, verticalMargin);
        this.dialogTop = Math.floor(topOffset) + 'px';
    }

    private initCanvas() {
        const canvas = this.$refs.canvas as HTMLCanvasElement;
        if (canvas) {
            this.ctx = canvas.getContext('2d');
            if (this.ctx) {
                this.applyDrawingStyle();
            }
        }
    }

    private drawImageOnCanvas() {
        if (!this.ctx || !this.originalImage) return;

        const canvas = this.$refs.canvas as HTMLCanvasElement;
        if (!canvas) return;
        
        // 清除整个Canvas
        this.ctx.clearRect(0, 0, canvas.width, canvas.height);
        
        // 确保Canvas尺寸与显示尺寸一致
        if (canvas.width !== this.displayWidth || canvas.height !== this.displayHeight) {
            canvas.width = this.displayWidth;
            canvas.height = this.displayHeight;
            // 重新获取context，因为改变Canvas尺寸会重置context
            this.ctx = canvas.getContext('2d');
            if (this.ctx) {
                this.applyDrawingStyle();
            }
        }
        
        // 再次检查ctx是否有效，因为可能在上面的操作中被重置
        if (!this.ctx) return;
        
        // 使用简化的绘制方式，确保图片完整显示
        this.ctx.drawImage(this.originalImage, 0, 0, this.displayWidth, this.displayHeight);
        
        console.log('图片已绘制到Canvas:', {
            canvasWidth: canvas.width,
            canvasHeight: canvas.height,
            displayWidth: this.displayWidth,
            displayHeight: this.displayHeight,
            naturalWidth: this.originalImage.naturalWidth,
            naturalHeight: this.originalImage.naturalHeight
        });
    }

    private onMouseDown(e: MouseEvent) {
        this.isDrawing = true;
        const rect = (e.target as HTMLCanvasElement).getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        this.currentPath = [{ x, y }];

        if (this.ctx) {
            this.applyDrawingStyle();
            this.ctx.beginPath();
            this.ctx.moveTo(x, y);
        }
    }

    private onMouseMove(e: MouseEvent) {
        if (!this.isDrawing || !this.ctx) return;

        const rect = (e.target as HTMLCanvasElement).getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        this.currentPath.push({ x, y });

        if (this.ctx) {
            this.ctx.lineTo(x, y);
            this.ctx.stroke();
        }
    }

    private onMouseUp(e: MouseEvent) {
        if (!this.isDrawing) return;

        this.isDrawing = false;

        if (this.currentPath.length > 0) {
            this.paths.push([...this.currentPath]);
            this.currentPath = [];
        }
    }

    private clearCanvas() {
        this.paths = [];
        this.currentPath = [];
        // 重新绘制图片，清除所有标注痕迹
        this.drawImageOnCanvas();
        console.log('Canvas已清除，所有标注痕迹已移除');
    }

    private cancel() {
        this.$emit('cancel');
        this.paths = [];
        this.currentPath = [];
        // 重新绘制图片，清除所有标注痕迹
        this.drawImageOnCanvas();
    }

    private async confirm() {
        try {
            // 重新绘制图片和所有标记
            this.drawImageOnCanvas();
            this.redrawAllPaths();

            // 生成带标记的图片
            const canvas = this.$refs.canvas as HTMLCanvasElement;
            
            // 尝试导出Canvas，如果失败则使用替代方案
            let dataURL: string;
            try {
                dataURL = canvas.toDataURL('image/png');
            } catch (canvasError) {
                console.warn('Canvas导出失败，使用替代方案:', canvasError);
                
                // 替代方案：创建一个新的Canvas，重新绘制
                const tempCanvas = document.createElement('canvas');
                tempCanvas.width = this.displayWidth;
                tempCanvas.height = this.displayHeight;
                const tempCtx = tempCanvas.getContext('2d');
                
                if (tempCtx && this.originalImage) {
                    // 重新绘制图片
                    tempCtx.drawImage(this.originalImage, 0, 0, this.displayWidth, this.displayHeight);
                    
                    // 重新绘制所有标记
                    tempCtx.strokeStyle = '#000000';
                    tempCtx.lineWidth = 2;
                    tempCtx.lineCap = 'round';
                    tempCtx.lineJoin = 'round';
                    
                    this.paths.forEach(path => {
                        if (path.length > 0) {
                            tempCtx.beginPath();
                            tempCtx.moveTo(path[0].x, path[0].y);
                            
                            for (let i = 1; i < path.length; i++) {
                                tempCtx.lineTo(path[i].x, path[i].y);
                            }
                            
                            tempCtx.stroke();
                        }
                    });
                    
                    dataURL = tempCanvas.toDataURL('image/png');
                } else {
                    throw new Error('无法创建临时Canvas');
                }
            }

            // 将base64转换为blob
            const response = await fetch(dataURL);
            const blob = await response.blob();

            // 创建FormData上传
            const formData = new FormData();
            
            // 创建一个完整的File对象，确保有size属性
            const file = new File([blob], 'marked-image.png', { 
                type: 'image/png',
                lastModified: Date.now()
            });
            
            // 验证文件对象
            console.log('生成的文件对象:', file);
            console.log('文件大小:', file.size);
            console.log('文件类型:', file.type);
            
            formData.append('file', file); // 使用'file'而不是'image'
            
            // 如果服务器需要特定的字段名，也可以尝试
            // formData.append('image', file);
            // formData.append('upload', file);

            // 调用上传接口
            const result = await UploadFile(this, formData);

            this.$message.success('图片上传成功');
            this.paths = [];
            this.currentPath = [];
            this.$emit('confirm', result.data);

        } catch (error) {
            this.$message.error('图片上传失败');
            console.error('上传失败:', error);
        }
    }

    private redrawAllPaths() {
        if (!this.ctx) return;

        this.ctx.strokeStyle = '#000000';
        this.ctx.lineWidth = 2;
        this.ctx.lineCap = 'round';
        this.ctx.lineJoin = 'round';

        this.paths.forEach(path => {
            if (path.length > 0 && this.ctx) {
                this.ctx.beginPath();
                this.ctx.moveTo(path[0].x, path[0].y);

                for (let i = 1; i < path.length; i++) {
                    this.ctx.lineTo(path[i].x, path[i].y);
                }

                this.ctx.stroke();
            }
        });
    }

    private applyDrawingStyle() {
        if (!this.ctx) return;
        this.ctx.strokeStyle = '#000000';
        this.ctx.lineWidth = 2;
        this.ctx.lineCap = 'round';
        this.ctx.lineJoin = 'round';
    }
}
